import { CultureInfo } from '../culture-info.model';
import { CultureInfoPt } from './pt';

/**
 * @ignore
 */
export const CultureInfoPtGW: CultureInfo = {
  name: 'pt-GW',
  displayName: 'português (Guiné-Bissau)',
  iso3LanguageCode: 'por',
  iso2LanguageCode: 'pt',
  ietfLanguageTag: 'pt-GW',
  parent: CultureInfoPt
};
